import type { InPageNavigationProps, INavSection } from './InPageNavigation';
import InPageNavigation, { NavSection } from './InPageNavigation';

export type { InPageNavigationProps, INavSection };
export { NavSection };
export default InPageNavigation;
